import fikra from "../assets/logos/fikra.jpeg";
import icdl from "../assets/logos/icdl.jpeg";
import iclon from "../assets/logos/iclon.jpeg";
import icrc from "../assets/logos/icrc.jpeg";
import idw from "../assets/logos/idw.jpeg";
import raspberry from "../assets/logos/raspberry.jpeg";
import reading from "../assets/logos/reading.jpeg";
import ssc from "../assets/logos/ssc.jpeg";
import unrwa from "../assets/logos/unrwa.jpeg";
import michiganUniversity from "../assets/logos/michigan.png";
import Udemey from "../assets/logos/Udemy.png";
import mendix_rapid from "../assets/logos/mendix.png";
import low_code_academy from "../assets/logos/low_code_academy.jpeg";
import UAF from "../assets/logos/uaf.png";
import PwC from "../assets/logos/pwc.png";



const courses = {
  english: [
    {
      title: "ESG and Managament",
      school: "PwC",
      location: "Amsterdam",
      date: "Aug 2024 - April 2024",
      period: "60 hours",
      certification: true,
      logo: PwC,
    },
    {
      title: "Microsoft Copilot Masterclass - Microsoft 365 Copilot Office",
      school: "Udemy",
      location: "Online",
      date: "April 2024",
      period: "Total: 6 hours",
      certification: true,
      logo: Udemey,
    },
    {
      title: "Smart Tips: Innovation",
      school: "Udemy",
      location: "Online",
      date: "March 2024",
      period: "Total: 2 hours",
      certification: true,
      logo: Udemey,
    },
    {
      title: "Software Architecture & Design of Modern Large Scale Systems",
      school: "Udemy",
      location: "Online",
      date: "Jan 2024",
      period: "Total: 7 hours",
      certification: true,
      logo: Udemey,
    },
    {
      title: "Collaborating with different cultures",
      school: "UAF",
      location: "Online",
      date: "Dec 2023",
      period: "3 hours",
      certification: true,
      logo: UAF,
    },
    {
      title: "Prompting and ChatGPT voor beginners",
      school: "UAF",
      location: "Online",
      date: "Dec 2023",
      period: "Total: 1.25 hours",
      certification: true,
      logo: UAF,
    },
    {
      title: "Better Feedback",
      school: "UAF",
      location: "Online",
      date: "Nov 2023",
      period: "Total: 3.30 hours",
      certification: true,
      logo: UAF,
    },
    {
      title: "Interactive presentation",
      school: "UAF",
      location: "Online",
      date: "Nov 2023",
      period: "Total: 1.15 hours",
      certification: true,
      logo: UAF,
    },
    {
      title: "Mendix Intermediate Developer Certification",
      school: "Mendix",
      location: "Online",
      date: "May 2023",
      period: "Official Exam",
      certification: true,
      logo: mendix_rapid,
    },
    {
      title: "Complete FastAPI masterclass from scratch",
      school: "Udemy",
      location: "Online",
      date: "May 2023",
      period: "Total: 21 hours",
      certification: true,
      logo: Udemey,
    },
    {
      title: "Mendix : Building a Pluggable Widgets With React Hooks",
      school: "Udemy",
      location: "Online",
      date: "May 2023",
      period: "Total: 7.5 hours",
      certification: true,
      logo: Udemey,
    },
    {
      title: "Mendix:Low-code Application Development ",
      school: "Udemy",
      location: "Online",
      date: "April 2023",
      period: "Total: 6.5 hours",
      certification: true,
      logo: Udemey,
    },
    {
      title: "Mendix Developer Bootcamp",
      school: "Low-Code Academy",
      location: "Amsterdam",
      date: "April 2023",
      period: "5 weeks - Full-time",
      certification: true,
      logo: low_code_academy,
    },
    {
      title: "Mendix Rapid Developer Certification",
      school: "Mendix",
      location: "Online",
      date: "Mar 2023",
      period: "10 days - Full-time",
      certification: true,
      logo: mendix_rapid,
    },
    {
      title: "Agile Scrum for Beginners + Scrum Master Certification",
      school: "Udemy",
      location: "Online",
      date: "Mar 2023",
      period: "3 Hours + 1 hour test",
      certification: true,
      logo: Udemey,
    },
    {
      title: "Programming for Everybody (Getting Started with Python)",
      school: "University of Michigan & Coursera",
      location: "Online",
      date: "Feb 2023",
      period: "7 weeks",
      certification: true,
      logo: michiganUniversity,
    },
    {
      title: "Introduction to Databases and SQL",
      school: "Raspberry Pi Foundation",
      location: "Online",
      date: "Aug 2022",
      period: "3 weeks",
      certification: true,
      logo: raspberry,
    },
    {
      title: "Training for teachers",
      school: "ICLON Universiteit Leiden",
      location: "Leiden - The Netherlands",
      date: "Aug 2016",
      period: "3 months",
      certification: true,
      logo: iclon,
    },
    {
      title: "Academic Bachelor's degree in Physics - WO",
      school: "Internationale Diplomawaardering (IDW)",
      location: "The Netherlands",
      date: "Jan 2016",
      period: "No period",
      certification: true,
      logo: idw,
    },
    {
      title: "Writing in English for University Study",
      school: "University of Reading",
      location: "Online",
      date: "May 2015",
      period: "4 weeks",
      certification: false,
      logo: reading,
    },
    {
      title: "CPR/AED/First Aid",
      school: "International Committee of the Red Cross - ICRC",
      location: "UNRWA - Syria",
      date: "Jan 2012",
      period: "1 week",
      certification: true,
      logo: icrc,
    },
    {
      title: "Training for trainers - programming LEGO robots",
      school: "Fikra Foundation",
      location: "Damascus - Syria",
      date: "Apr 2012",
      period: "4 months - ( Intensive course )",
      certification: true,
      logo: fikra,
    },
    {
      title: "Microcontrollers & Interface - Programming",
      school: "Specialist Sciences Center - SSC",
      location: "Damascus - Syria",
      date: "Jun 2010",
      period: "4 months - ( Intensive course )",
      certification: true,
      logo: ssc,
    },
    {
      title: "PLC ( programmable Logical controllers )",
      school: "UNRWA - UN",
      location: "Damascus - Syria",
      date: "Jun 2009",
      period: "3 months - ( Intensive course )",
      certification: true,
      logo: unrwa,
    },
    {
      title: "ICDL - International Computer Drivers License.",
      school: "ICDL Certification",
      location: "Damascus - Syria",
      date: "Jan 2007",
      period: "No period",
      certification: true,
      logo: icdl,
    },
  ],
  arabic: [
    {
      title: "ميندكس: تطوير تطبيقات الكود المنخفض",
      school: "Udemy",
      location: "عبر الإنترنت",
      date: "April 2023",
      period: "الوقت الكامل للفيديوهات: ست ساعات ونصف",
      certification: true,
      logo: Udemey,
    },
    {
      title: "برنامج تدريبي في تطوير ميندكس",
      school: "Low-Code Academy",
      location: "Amsterdam",
      date: "April 2023",
      period: "خمسة أسابيع , دوام كامل",
      certification: true,
      logo: low_code_academy,
    },
    {
      title: "شهادة مطور ميندكس السريع",
      school: "Mendix",
      location: "عبر الانترنت",
      date: "Mar 2023",
      period: "عشرة أيام , دوام كامل",
      certification: true,
      logo: mendix_rapid,
    },
    {
      title: "إدارة مشاريع أجايل للمبتدئين و شهادة سكرم",
      school: "Udemy",
      location: "عبر الانترنت",
      date: "Mar 2023",
      period: "ثلاث ساعات فيديو + ساعة اختبار",
      certification: true,
      logo: Udemey,
    },
    {
      title: "البرمجة للجميع (بدء استخدام بايثون)",
      school: "University of Michigan & Coursera",
      location: "عبر الإنترنت",
      date: "Feb 2023",
      period: "سبعة أسابيع",
      certification: true,
      logo: michiganUniversity,
    },
    {
      title: "مدخل إلى قواعد البيانات ",
      school: "Raspberry Pi Foundation",
      location: "عبر الإنترنت",
      date: "Aug 2022",
      period: "ثلاثة أسابيع",
      certification: true,
      logo: raspberry,
    },
    {
      title: "تدريب للمدرسين في هولندا",
      school: "جامعة لايدن",
      location: "لايدن - هولندا",
      date: "Aug 2016",
      period: "ثلاثة شهور",
      certification: true,
      logo: iclon,
    },
    {
      title: "درجة البكالوريوس الأكاديمية في الفيزياء",
      school: "Internationale Diplomawaardering (IDW)",
      location: "هولندا",
      date: "Jan 2016",
      period: "غير منتهية الصلاحية",
      certification: true,
      logo: idw,
    },
    {
      title: "الكتابة باللغة الإنكليزية للدراسة الأكاديمية",
      school: "University of Reading",
      location: "عبر الإنترنت",
      date: "May 2015",
      period: "أربعة أسابيع",
      certification: false,
      logo: reading,
    },
    {
      title: "دورة الإسعافات الأولية",
      school: "الصليب الأحمر الدولي",
      location: "الأنروا - سوريا",
      date: "Jan 2012",
      period: "أسبوع واحد",
      certification: true,
      logo: icrc,
    },
    {
      title: "تدريب المدربين في برمجة روبوتات ليغو",
      school: "مؤسسة فكرة",
      location: "دمشق - سوريا",
      date: "Apr 2012",
      period: "دورة مكثفة لمدة أربعة أشهر",
      certification: true,
      logo: fikra,
    },
    {
      title: "برمجة المتحكمات الصغرية و الواجهات",
      school: "مركز العلوم التخصصي",
      location: "دمشق - سوريا",
      date: "Jun 2010",
      period: "دورة مكثفة لمدة أربعة أشهر",
      certification: true,
      logo: ssc,
    },
    {
      title: "برمجة المتحكمات المنطقية القابلة للبرمجة",
      school: "الأنروا",
      location: "دمشق - سوريا",
      date: "Jun 2009",
      period: "دورة مكثفة لمدة ثلاثة أشهر",
      certification: true,
      logo: unrwa,
    },
    {
      title: "شهادة قيادة الحاسب الدولية",
      school: "الشهادة الدولية",
      location: "دمشق - سوريا",
      date: "Jan 2007",
      period: "غير محدودة المدة",
      certification: true,
      logo: icdl,
    },
  ],
};

export default courses;
